enum DataStoreCachingType {
    none,
    session,
    local,
    sharedMemory
}

export default DataStoreCachingType;